import { useState } from 'react';

const faqs = [
  {
    q: 'What is a Fractional Head of AI?',
    a: 'A Fractional Head of AI is an experienced AI executive who works with your company on a part-time or project basis. You get the strategic leadership and technical expertise of a seasoned AI leader — without the cost of a full-time C-suite hire. Peter embeds with your team, understands your business, and drives your AI initiatives forward.',
  },
  {
    q: 'What types of businesses do you work with?',
    a: 'Peter works with businesses of all sizes — from startups looking to build their first AI product to mid-market companies wanting to scale AI across their operations, to enterprises seeking to modernize legacy systems with AI. Industries include healthcare, finance, retail, logistics, and professional services.',
  },
  {
    q: 'How quickly can we get started?',
    a: 'After an initial discovery call, most engagements can begin within 1–2 weeks. Peter moves quickly to assess your current state, identify high-impact opportunities, and start delivering value from day one.',
  },
  {
    q: 'What does an AI consulting engagement look like?',
    a: 'Engagements typically start with a comprehensive AI readiness assessment, followed by strategy development, roadmap creation, and hands-on execution support. We work closely with your team throughout — from ideation to deployment — ensuring AI initiatives are practical, scalable, and aligned with business goals.',
  },
  {
    q: 'Do you build custom AI solutions?',
    a: 'Yes. Peter\'s team builds custom AI solutions including chatbots, voice agents, automation pipelines, recommendation engines, and more. Every solution is tailored to your specific use case, integrated with your existing systems, and built for long-term maintainability.',
  },
  {
    q: 'What is VoiceCal and how can it help my business?',
    a: 'VoiceCal is an AI-powered voice booking system that allows customers to schedule appointments naturally over the phone — no apps, no forms, just conversation. It\'s ideal for service businesses like medical practices, salons, law firms, and any business that relies on appointment scheduling.',
  },
  {
    q: 'How do you measure the success of AI projects?',
    a: 'Success is measured against clear, pre-defined business metrics — such as cost reduction, revenue increase, time savings, customer satisfaction scores, or conversion rates. Peter establishes KPIs at the start of every engagement and provides regular reporting on progress and ROI.',
  },
  {
    q: 'What makes us different from other AI consultants?',
    a: 'We bring a rare combination of deep technical expertise (25+ years at Cisco, 40+ patents) and executive leadership experience. We don\'t just advise — we roll up our sleeves and build. Our track record of delivering $2B+ in revenue impact speaks to our ability to translate AI potential into real business results. Now is the best time to act, before your competitors find us.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-24 px-6 lg:px-12 bg-white">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-teal-50 text-teal-600 text-sm font-semibold rounded-full mb-4 tracking-wide uppercase">
            FAQ
          </span>
          <h2 className="font-['Playfair_Display'] text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Everything you need to know about working with Peter and his AI services.
          </p>
          <div className="w-16 h-1 bg-teal-500 mx-auto rounded-full mt-6"></div>
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`rounded-xl border transition-all duration-200 overflow-hidden ${openIndex === i ? 'border-teal-300 shadow-sm' : 'border-gray-200'}`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-gray-50 transition-colors duration-150"
              >
                <span className={`font-semibold text-base pr-4 ${openIndex === i ? 'text-teal-700' : 'text-gray-900'}`}>
                  {faq.q}
                </span>
                <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-200 ${openIndex === i ? 'bg-teal-500 text-white rotate-180' : 'bg-gray-100 text-gray-500'}`}>
                  <i className="ri-arrow-down-s-line text-lg"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
